import { useQuery } from '@tanstack/react-query';
import { DictResponse } from '@spilca/order_ts/v1/order/enum_pb';
import { QUERY_KEYS } from '@monorepo/helpers';
import { useI18n } from '@monorepo/i18n';
import { translateNormalizedDictionary } from '@monorepo/dictionary';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useGetLogisticsOperator = (
  filter: object | undefined,
  active: string | null = null
) => {
  const { t } = useI18n();
  const getLogisticsOperator = useGetRequest(
    REQUEST_TYPES.GET_FAST_DEALS_LOGISTICS_OPERATOR_REQUEST
  );
  return useQuery({
    queryKey: [QUERY_KEYS.LIST_FAST_DEALS_LOGISTICS_OPERATOR, filter],
    queryFn: (d): Promise<DictResponse.AsObject> =>
      getLogisticsOperator({ ...d, active }),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 10*60*1000,
    gcTime: 2 * 60 * 1000,
    placeholderData: (previousData) => previousData,
    select: translateNormalizedDictionary(
      ({ name }) => t(`logistics.${name}`),
      null,
      'id',
      (item) => `logistics-${item.id}`
    )
  });
};

export default useGetLogisticsOperator;
